import { LoadSubscribedMappings, SubscribedModelPortfoliosAction } from './subscribed-model-portfolios.actions';
import * as actions from './subscribed-model-portfolios.actions';
import { subscribedModelPortfoliosInitialState } from './subscribed-model-portfolios.init';
import { SubscribedModelPortfoliosState } from './subscribed-model-portfolios.interfaces';

export function subscribedModelPortfoliosReducer(state = subscribedModelPortfoliosInitialState, action: SubscribedModelPortfoliosAction): SubscribedModelPortfoliosState {
	switch (action.type) {
		case actions.LOAD_SUBSCRIBED_MAPPINGS: {
			const actionPayload = (<LoadSubscribedMappings>action).subscribedPortfolioMapping;
			return {
				subscribedPortfolioMapping: actionPayload
			};
		}
		case actions.ADD_SUBSCRIPTION_STORE_MAPPING: {
			const newMapping = (<actions.AddSubscriptionStoreMapping>action).newMapping;

			const updatedMappings: Map<string, string> = getCombinedCopy(state.subscribedPortfolioMapping, newMapping);

			return {
				subscribedPortfolioMapping: updatedMappings
			};
		}
		case actions.REMOVE_SUBSCRIPTION_STORE_MAPPING: {
			const portfolioId = (<actions.RemoveSubscriptionStoreMapping>action).portfolioId;

			const success: boolean = state.subscribedPortfolioMapping.delete(portfolioId);

			if (!success) {
				console.warn(`Unsuccessful delete of portfolio ID: ${portfolioId} from ${JSON.stringify(state.subscribedPortfolioMapping, null, 2)}`);
			}

			const updatedMappings: Map<string, string> = getCombinedCopy(state.subscribedPortfolioMapping);

			return {
				subscribedPortfolioMapping: updatedMappings
			};
		}
		default: {
			return state;
		}
	}

	function getCombinedCopy<K, V>(...maps: Map<K, V>[]): Map<K, V> {
		const combinedCopy: Map<K, V> = new Map<K, V>();

		maps.forEach(map => {
			map.forEach((value, key) => {
				combinedCopy.set(key, value);
			});
		});

		return combinedCopy;
	}
}
